/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListBusinessMemoryContentScopesSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type ListBusinessMemoryContentScopesRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListBusinessMemoryContentScopesSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListBusinessMemoryContentScopesSecurity$outboundSchema:
  z.ZodMiniType<
    ListBusinessMemoryContentScopesSecurity$Outbound,
    ListBusinessMemoryContentScopesSecurity
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.optional(z.string()),
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listBusinessMemoryContentScopesSecurityToJSON(
  listBusinessMemoryContentScopesSecurity:
    ListBusinessMemoryContentScopesSecurity,
): string {
  return JSON.stringify(
    ListBusinessMemoryContentScopesSecurity$outboundSchema.parse(
      listBusinessMemoryContentScopesSecurity,
    ),
  );
}

/** @internal */
export type ListBusinessMemoryContentScopesRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListBusinessMemoryContentScopesRequest$outboundSchema:
  z.ZodMiniType<
    ListBusinessMemoryContentScopesRequest$Outbound,
    ListBusinessMemoryContentScopesRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      gramProject: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramProject: "Gram-Project",
      });
    }),
  );

export function listBusinessMemoryContentScopesRequestToJSON(
  listBusinessMemoryContentScopesRequest:
    ListBusinessMemoryContentScopesRequest,
): string {
  return JSON.stringify(
    ListBusinessMemoryContentScopesRequest$outboundSchema.parse(
      listBusinessMemoryContentScopesRequest,
    ),
  );
}
